import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import {
  ApplicationInsights,
  DistributedTracingModes
} from '@microsoft/applicationinsights-web';

const reactPlugin = new ReactPlugin();
const clickPluginInstance = new ClickAnalyticsPlugin();

const clickPluginConfig = {
  autoCapture: true
};

export const appInsights = new ApplicationInsights({
  config: {
    connectionString:
      process.env.REACT_APP_APPLICATION_INSIGHTS_CONNECTION || '',
    enableAutoRouteTracking: true,
    enableCorsCorrelation: true,
    distributedTracingMode: DistributedTracingModes.W3C,
    correlationHeaderDomains: [
      new URL(process.env.REACT_APP_BACKEND_API_URL || '').hostname
    ],
    extensions: [reactPlugin, clickPluginInstance],
    extensionConfig: {
      [clickPluginInstance.identifier]: clickPluginConfig
    }
  }
});

appInsights.loadAppInsights();
appInsights.trackPageView();

export const getCurrentTraceId = (): string | undefined =>
  appInsights.context?.telemetryTrace?.traceID;

export { reactPlugin };
